import { inject, Injectable, signal } from '@angular/core';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { PDPRepository } from '@repos/pdp.repository';
import { HotelInfoUiService } from './hotel-info-ui.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';
import { log } from 'console';

@Injectable({
 providedIn: 'root',
})
export class EcolodgeService {
 hotelinfoRepo = inject(PDPRepository);
 searchBoxService = inject(SearchBoxService);
 pdpUiService = inject(HotelInfoUiService);
 datepickerService = inject(DatepickerService);
 persianToEnglishPipe = inject(PersianToEnglishRegexPipe);
 CalenderDetails: any = {};
 isCalenderPriceFetched = signal(false);

 constructor() {}

 getProformaAccommodation(
  houseId: string,
  date: string,
  endDate: string,
  FixedGuestCount: string,
  ExtraGuestCount: string,
  type: string
 ) {
  return this.hotelinfoRepo.getProformaEcolodge(
   date,
   endDate,
   FixedGuestCount,
   ExtraGuestCount,
   houseId,
   type
  );
 }

 getCalenderDetails(startDate: string, endDate: string) {
  this.pdpUiService
   .getEcolodgeCalenderDetails(
    {
     StartDate: startDate,
     EndDate: startDate,
    },
    {
     hotelId: this.pdpUiService.hotelId?.toString(),
     houseId: this.pdpUiService.hosueId?.toString(),
     type: this.pdpUiService.hotelInfo().Type.toString(),
    },
    false
   )
   .subscribe((details: any) => {
    ('in ecolodge calender subscription');
    // this.roomInfo = details.Room?.RoomContainer[0]?.RoomInfos[0];
    // this.pdpUiService.ecolodgeRoomInfo.set([
    //  {
    //   id:
    //    this.hotelInfoSummary?.Type == 1
    //     ? details.Room?.RoomContainer[0]?.Id
    //     : this.hotelInfoSummary?.HouseId,
    //   quantity: 1,
    //   index: 0,
    //   nonRefundable: this.roomInfo?.RoomDetail?.NonRefundable,
    //  },
    // ] as any);

    let mappedDates: Map<string, any> = new Map();
    (this.pdpUiService.hotelInfo().Type == 2
     ? details.Days
     : details.Room.RoomContainer[0].RoomInfos[0].RoomAvailableDate.Dates
    ).forEach((eachDate: any) => {
     this.datepickerService.ecolodgeCalenderDetails.update((data) =>
      (data as Map<string, any>).set(
       this.persianToEnglishPipe.transform(eachDate.DatePersian),
       eachDate
      )
     );
    });
    this.datepickerService.isNextMonthLoading.set(false);
    this.datepickerService.isPrevMonthLoading.set(false);

    //   this.getDateDetail.transform(this.datepickerService.ecolodgeCalenderDetails().Days);
    // this.datepickerService.ecolodgeCalenderDetails.set(mappedDates);
    // return mappedDates;
    // this.datepickerService.setCalenderDetails(mappedDates);


    this.CalenderDetails = details;
    this.isCalenderPriceFetched.set(true);

    //  this.openDatePicker(details.Room?.RoomContainer[0]?.RoomInfos[0].RoomAvailableDate.Dates);
   });
 }
}
